export default __webpack_public_path__ + "static/media/1Klein.f170c89e.jpg";